import { useQuery } from '@tanstack/react-query';
import alb from 'services/api/alb';
const exportGeneric = async <Params,>(module: string, params: Params) => {
	const response = await alb.get(`/${module}/export-csv`, {
		params,
	});
	return response.data;
};

export const useExport = <Params,>(
	module: string,
	params: Params | undefined
) => {
	return useQuery(
		['export-csv', module, JSON.stringify(params)],
		() => exportGeneric(module, params),
		{
			refetchOnWindowFocus: false,
			retry: 1,
			enabled: false,
		}
	);
};
